import { atomWithStorage } from 'jotai/utils'
import { createReader } from '../../utils/atomReader'
import { type ScannedContainer } from 'client/scanner/scanner.types'
import type { ProductWithStock, ProductWithAlertInfo } from 'types/model'
import { MoveOption } from './Storage.types'

export const selectedContainerAtom = atomWithStorage<ScannedContainer | undefined>('Storage:selectedContainerAtom', undefined)
export const selectedContainerReader = createReader(selectedContainerAtom)

export const productsInContainerAtom = atomWithStorage<ProductWithStock[]>('Storage:productsInContainerAtom', [])
export const productsInContainerReader = createReader(productsInContainerAtom)

export const selectedProductsAtom = atomWithStorage<ProductWithAlertInfo[]>('Storage:selectedProductsAtom', [])
export const selectedProductsReader = createReader(selectedProductsAtom)

export const moveOptionAtom = atomWithStorage<MoveOption | null>('Storage:selectedProductsAtom', null)